import React, { Component } from "react";
import Container from "../../../../modules/commons/Container";
import {
  flattenFormGroupObject,
  getValueFromDDL,
  mapToObjectDDL,
  removeNullFields,
} from "../../../common/mapper";
import SimpleDDL from "../../../../modules/SimpleDDL";
import Api from "../../../../Services/Api";
import { contructQueryParam, fetchDataAsync } from "../../../../Services/Utils";
import { HttpStatus } from "../../../common/Constants";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import ErrorAction from "../../../../Redux/ErrorRedux";
import { connect } from "react-redux";
import CrmCDBTab from "./components/crmCDBTab";
import { config } from "./config";
import FlexView from "react-flexview";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import { transformProspectData } from "./service";
import * as R from "ramda";
import M from "moment";
import { downloadExcel } from "./downloadUtils";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";

class CrmCDB extends Component {
  constructor(props) {
    super(props);
    const defaultOperator = { label: "=", value: "=" };
    this.state = {
      deleteCabang: false,
      dataMotor: false,
      loading: false,
      activeTab: "create_prospek",
      activeTabIndex: 0,
      activityType: null,
      filterVisible: false,
      detailVisible: false,
      confirmationVisible: false,
      numberOfEligible: 0,
      numberOfNotEligible: 0,
      selectedData: null,
      eligibleData: null,
      kodeCabang: [],
      filterData: {
        filterH1: {
          operatorTanggalBeliTerakhir: { label: "=", value: "=" },
          tanggalBeliTerakhir: M().format("DD-MM-YYYY"),
        },
        filterH23: {
          pembandingServiceTerakhir: { label: "=", value: "=" },
          tanggalServiceTerakhir: M().format("DD-MM-YYYY"),
        },
      },
      dataChangeRequest: {},
      tempDataChangeRequest: {},
      cabangOptions: [],
      tableColumns: [],
      tableColumns2: config.tableColumnMotorDimiliki,
      alertModalValidationVisible: false,
      dataTable: [],
      dataTable2: [],
      pagination: {
        totalData: 0,
        page: 1,
        limit: 5,
      },
      pagination2: {
        totalData: 0,
        page: 1,
        limit: 5,
      },
      firstLoad: true,
      cekfilter: false,
      resetFilter: false,
      prospectCategory: null
    };
  }

  getTableColumns(activeTabs = "create_prospek") {
    let columns;
    if (activeTabs === "create_prospek") {
      columns = [...config.tableColumnCalonProspek];
      columns.push({
        name: "action",
        label: "Aksi",
        options: {
          customBodyRender: (_, tableMeta) => (
            <FlexView hAlignContent="center" style={{ gap: 10 }}>
              <SimpleButton
                type="button"
                category="action_button"
                icon={
                  <i
                    style={{ fontSize: 20, color: "red" }}
                    className="fa fa-lg fa-eye"
                  />
                }
                onClick={() =>
                  this.handleShowDetail(tableMeta.rowIndex, "VIEW")
                }
              />
              <SimpleButton
                type="button"
                category="action_button"
                icon={
                  <i
                    style={{ fontSize: 20, color: "red" }}
                    className="fa fa-lw fa-pencil-alt"
                  />
                }
                onClick={() =>
                  this.handleShowDetail(tableMeta.rowIndex, "UPDATE")
                }
              />
            </FlexView>
          ),
          sort: false,
        },
      });
    } else {
      columns = [...config.tableColumnChangeData];
      columns.push({
        name: "action",
        label: "Aksi",
        options: {
          customBodyRender: (_, tableMeta) => (
            <FlexView hAlignContent="center" style={{ gap: 10 }}>
              <SimpleButton
                type="button"
                category="action_button"
                icon={
                  <i
                    style={{ fontSize: 20, color: "red" }}
                    className="fa fa-lw fa-pencil-alt"
                  />
                }
                onClick={() =>
                  this.handleShowDetail(tableMeta.rowIndex, "VIEW")
                }
              />
            </FlexView>
          ),
          sort: false,
        },
      });
    }

    return columns;
  }

  componentDidMount = async () => {
    this.handleTriggerLoading();
    let cabangOptions = [];

    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
      setError: this.props.setError,
      menuName: "CRM - Manajemen CDB",
      args: {},
    });

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      let filteredData = res.data.data.filter((item) =>
        this.props.menuAccess
          .map((data) => data.idRefObj)
          .includes(item.kodeCabang)
      );
      if (filteredData.length !== 0) {
        cabangOptions = filteredData.map((item) =>
          mapToObjectDDL(item.namaDealer, item.kodeCabang)
        );
      }
    }

    this.setState((prevState) => ({
      ...prevState,
      tableColumns: this.getTableColumns(),
      cabangOptions,
    }));
    this.handleTriggerLoading();
  };

  componentDidUpdate = async (prevProps, prevState) => {
    if (prevState.activeTab !== this.state.activeTab) {
      this.handleTriggerLoading();
      await this.setState((prevState) => ({
        ...prevState,
        tableColumns: this.getTableColumns(this.state.activeTab),
        pagination: {
          totalData: 0,
          page: 1,
          limit: 5,
        },
      }));
      await this.callApi();
      this.handleTriggerLoading();
    }

    if (
      prevState.kodeCabang?.length !== this.state.kodeCabang?.length &&
      !R.isNil(this.state.kodeCabang)
    ) {
      this.handleTriggerLoading();
      await this.setState((prevState) => ({
        ...prevState,
        dataTable: [],
        dataTable2: [],
        pagination: {
          totalData: 0,
          page: 1,
          limit: 5,
        },
        pagination2: {
          totalData: 0,
          page: 1,
          limit: 5,
        },
      }));
      if (this.state.kodeCabang.length > 0) {
        await this.callApi();
      }
      this.handleTriggerLoading();
    }

    if (
      (prevState.pagination.page !== this.state.pagination.page ||
        prevState.pagination.limit !== this.state.pagination.limit) &&
      !R.isNil(this.state.kodeCabang)
    ) {
      this.handleTriggerLoading();
      await this.callApi();
      this.handleTriggerLoading();
    }

    if (this.state.kodeCabang === null) {
      this.setState((prevState) => ({
        ...prevState,
        kodeCabang: [],
      }));
    }
  };

  callApi = async () => {
    if (this.state.activeTab === "create_prospek") {
      await this.fetchCreateProspek(
        { ...this.state.filterData },
        this.state.pagination.page,
        this.state.pagination.limit
      );
    } else {
      await this.fetchChangeData(
        { ...this.state.filterData },
        this.state.pagination.page,
        this.state.pagination.limit
      );
    }
  };

  handleShowDetail = (index, action) => {
    this.setState((prevValue) => ({
      ...prevValue,
      detailVisible: !prevValue.detailVisible,
      selectedData: this.state.dataTable[index],
      activityType: action,
    }));
  };

  handleVisibletConfirm = () => {
    this.setState((prevState) => ({
      ...prevState,
      visibleConfirm: !prevState.visibleConfirm
    }));
  };

  handleSetState = (callback) => {
    this.setState(callback);
  };

  handleChangeKodeCabang = (value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      kodeCabang: value,
    }));
  };

  handleTabSelect = async (index) => {
    const tabNames = ["create_prospek", "change_data"];
    await this.setState((prevValue) => ({
      ...prevValue,
      activeTabIndex: index,
      activeTab: tabNames[index],
      filterData: {
        filterCDB: {
          ...(index === 1
            ? {
                startDatePeriod: M().format("DD-MM-YYYY"),
                endDatePeriod: M().format("DD-MM-YYYY"),
              }
            : {}),
        },
      },
    }));
  };

  checkEligibleNIKForProspect = async (isH23) => {
    this.handleTriggerLoading();
    const listNik = this.state.selectedData?.map((item) => item.nik);

    if (listNik === undefined) {
      this.handleAlertModalValidationVisibility();
    } else {
      let res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_TRANSACTION").checkEligibleNIKForProspect,
        setError: this.props.setError,
        menuName: "CRM - Manajemen CDB",
        args: {
          listNik: listNik,
          prospectCategory: isH23 ? "H23" : "H1" 
        },
      });
      if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        let { data } = res.data;
        let listEligible = data.filter((i) => i.isEligible).map((i) => i.nik);
        let listNotEligible = data.filter((i) => !i.isEligible);
        await this.setState((prevState) => ({
          ...prevState,
          numberOfEligible: listEligible.length,
          numberOfNotEligible: listNotEligible.length,
          eligibleData: listEligible,
          prospectCategory: isH23 ? "H23" : "H1" 
        }));
        this.handleConfirmationVisibility();
      }
    }

    this.handleTriggerLoading();
  };

  handleConfirmationVisibility = () => {
    this.setState((prevState) => ({
      ...prevState,
      confirmationVisible: !prevState.confirmationVisible,
    }));
  };

  createProspectH1 = async () => {
    this.handleTriggerLoading();
    const listNik = this.state.eligibleData;
    const fn = this.state.prospectCategory === "H1" ? "submitToH1CDBManagement" : "submitToH23CDBManagement"
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION")[fn],
      setError: this.props.setError,
      menuName: "CRM - Manajemen CDB",
      args: listNik,
    });

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.handleAlertModalSaveVisibility();
      this.handleTriggerLoading();
      this.handleConfirmationVisibility();
      // this.handleRefreshPagination();
      // await this.fetchCreateProspek();
      await this.fetchCreateProspek(
        this.state.filterData,
        this.state.pagination.page,
        this.state.pagination.limit
      );
      this.handleTriggerLoading();
    }
    this.handleTriggerLoading();
  };

  handleAlertModalSaveVisibility = () => {
    this.setState((prevState) => ({
      ...prevState,
      alertModalSaveVisible: !prevState.alertModalSaveVisible,
    }));
  };

  handleAlertModalValidationVisibility = () => {
    this.setState((prevState) => ({
      ...prevState,
      alertModalValidationVisible: !prevState.alertModalValidationVisible,
    }));
  };

  createProspectH23 = () => {};

  print = async () => {
    console.log( this.state.pagination);
    
    try {
      let filter = this.state.filterData;
      const cleanedFilter = this.removeEmptyFilterGroups(filter);
      if (this.state.kodeCabang.length === 0) return;

      let args = {
        listKodeCabang: this.state.kodeCabang.map((item) => item.value),
        page: this.state.pagination.page,
        limit: this.state.pagination.limit
      };

      // if (this.state.cekfilter) {
      //   const cleanedFilter = this.removeEmptyFilterGroups(filter);
      //   args = { ...args, ...cleanedFilter };
      // }

      if (this.state.kodeCabang.length === 0) {
        this.props.setError("Pilih minimal satu cabang untuk mengunduh data.");
        return;
      }

      let res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_TRANSACTION_FILE")
          .exportToExcelManagementCDB,
        setError: this.props.setError,
        menuName: "CRM Management CDB",
        args
      });

      if (!res || !res.data) {
        this.props.setError("Gagal mengunduh file. Data tidak tersedia.");
        return;
      }

      const filename = `Data_Prospek_${M().format("DDMMYYYY")}.xlsx`;
      downloadExcel(res.data, filename);
    } catch (error) {
      console.error("Error saat mengunduh file Excel:", error);
      this.props.setError("Terjadi kesalahan saat mengunduh file.");
    }
  };

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  removeEmptyFilterGroups = (obj) => {
    if (!obj || typeof obj !== "object") return {};

    const isObjectEmpty = (o) =>
      o &&
      typeof o === "object" &&
      Object.values(o).every(
        (val) =>
          val === null ||
          (Array.isArray(val) && val.length === 0) ||
          (typeof val === "object" && Object.keys(val).length === 0)
      );

    return Object.entries(obj).reduce((acc, [key, val]) => {
      if (!isObjectEmpty(val)) {
        acc[key] = val;
      }
      return acc;
    }, {});
  };

  fetchCreateProspek = async (filter = {}, page = 1, limit = 5) => {
    if (this.state.kodeCabang.length === 0) return;
    let args = {
      listKodeCabang: this.state.kodeCabang.map((item) => item.value),
      limit,
      page
    };

    console.log(this.state.cekfilter);
    console.log(filter);
    
    if (this.state.cekfilter) {
      const cleanedFilter = this.removeEmptyFilterGroups(filter);
      args = { ...args, ...cleanedFilter, limit, page };
    }

    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getDataForCreateProspect,
      setError: this.props.setError,
      menuName: "CRM Management CDB",
      args,
    });

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const data = res.data.data || [];
      this.setState((prevValue) => ({
        ...prevValue,
        dataTable: data,
        dataTableMotor: data.length > 0 ? prevValue.dataTableMotor : [],
        pagination: {
          ...prevValue.pagination,
          totalData: res.data.totalData,
        },
        deleteCabang: true,
        firstLoad: false,
        cekfilter: false,
      }));
      this.handleAfterFetchProspek()
    } else {
      this.setState((prevValue) => ({
        ...prevValue,
        dataTable: [],
        cekfilter: false,
        // cekfilter: false,
        dataTableMotor: [],
        pagination: {
          ...prevValue.pagination,
          totalData: 0,
        },
      }));
    }
  };

  handleAfterFetchProspek = () => {
    if (this.state.resetFilter) {
      const defaultFilterData = {
        filterH1: {
          operatorTanggalBeliTerakhir: { label: "=", value: "=" },
          tanggalBeliTerakhir: M().format("DD-MM-YYYY"),
        },
        filterH23: {
          pembandingServiceTerakhir: { label: "=", value: "=" },
          tanggalServiceTerakhir: M().format("DD-MM-YYYY"),
        },
      };
    
      this.setState({
        filterData: defaultFilterData,
        resetFilter: false, 
      });
    }
  };

  fetchChangeData = async (filter = {}, page = 1, limit = 5) => {
    if (this.state.kodeCabang.length === 0) return;
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getDataForRequestUpdate,
      setError: this.props.setError,
      menuName: "CRM Management CDB",
      args: {
        listKodeCabang: [...this.state.kodeCabang.map((item) => item.value)],
        limit: limit,
        page: page,
        ...filter,
      },
    });

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      let { data } = res.data;
      this.setState((prevValue) => ({
        ...prevValue,
        dataTable: !R.isNil(data) ? data : [],
        pagination: {
          ...prevValue.pagination,
          totalData: res.data.totalData,
        },
        deleteCabang: true,
      }));
    }
  };

  handleSaveCreateProspect = async (controls) => {
    let formData = flattenFormGroupObject(controls);
    let transformedData = transformProspectData(formData);

    this.handleTriggerLoading();
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION")
        .processToCustomerProfileCDMManagement,
      setError: this.props.setError,
      menuName: "CRM Management CDB",
      args: transformedData,
    });
     
    if (res.data.data.exist) {
      this.setState((prevState) => ({
          ...prevState,
          responseContent: `Pengajuan tidak dapat dilakukan sebelum pengajuan dengan No. Request : <b>${res.data.data.approvalId}</b> dilakukan keputusan <b>APPROVE/REJECT</b>`,
      }))
      this.handleVisibletConfirm()
    } else {
      this.handleShowDetail();
      await this.fetchCreateProspek(
        this.state.filterData,
        this.state.pagination.page,
        this.state.pagination.limit
      );
    }

    this.handleTriggerLoading();
  };

  handleCancelChangeRequest = async (nik) => {
    this.handleTriggerLoading();
    await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION")
        .updateStatusRequestUpdateCDMManagement,
      setError: this.props.setError,
      menuName: "CRM Management CDB",
      args: contructQueryParam({
        id: this.state.selectedData.id,
        status: "TOLAK",
      }),
    });

    this.handleShowDetail();
    await this.fetchChangeData(
      this.state.filterData,
      this.state.pagination.page,
      this.state.pagination.limit
    );
    this.handleTriggerLoading();
  };

  handleProcessChangeRequest = async (id) => {
    this.handleTriggerLoading();
    let req = this.state.tempDataChangeRequest;
    req.id = id;
    await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION")
        .processFromRequestUpdateCDBManagement,
      setError: this.props.setError,
      menuName: "CRM Management CDB",
      args: req,
    });

    this.handleShowDetail();
    await this.fetchChangeData(
      this.state.filterData,
      this.state.pagination.page,
      this.state.pagination.limit
    );
    this.handleTriggerLoading();
  };

  handleModalFilterVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterVisible: !prevValue.filterVisible,
    }));
  };

  handleResetFilter = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterData: {
        filterCDB: {
          agama: null,
          jenisKelamin: null,
          province: null,
          kabkot: null,
          kecamatan: null,
          kelurahan: null,
          kodePos: null,
          memberLevel: null,
          loyaltyLevel: null,
          facebook: null,
          instagram: null,
          x: null,
          linkedin: null,
          tiktok: null,
          hobby: null,
          interest: null,
          kategoriDisc: null,
          kategoriKhusus: null,
        },
        filterH1: {
          tanggalFJ: null,
          listSeries: null,
          listTipe: null,
          listVarian: null,
          listWarna: null,
          jenisPenjualan: null,
          jenisKonsumen: null,
          leasing: null,
          operatorTanggalBeliTerakhir: { label: "", value: "" },
        },
        filterH23: {
          statusKPB1: null,
          statusKPB2: null,
          statusKPB3: null,
          statusKPB4: null,
          pembandingPengeluaran: null,
          pembandingServiceTerakhir: null,
          job: null,
          part: null,
        },
      },
      firstLoad: false,
    }));
    this.setState((prevState) => ({
      ...prevState,
      resetFilter: true,
      cekfilter: false
    }));
  };

  handleSubmitFilter = async () => {
    this.handleTriggerLoading();
    this.handleRefreshPagination(true);
    this.setState((prevState) => ({
      ...prevState,
      // cekfilter: this.state.resetFilter ? false : true,
      cekfilter: true,
    }), () => this.reFetchApi());
    
    this.handleModalFilterVisibility();
    this.handleTriggerLoading();
  };

  reFetchApi = async (search = false) => {
    const { page, limit } = this.state.pagination;
    if (this.state.activeTab === "create_prospek") {
      await this.fetchCreateProspek(this.transformFilterData(search));
    } else {
      await this.fetchChangeData(this.transformFilterData(search), page, limit);
    }
  };

  transformFilterData = (search = false) => {
    let listKodeCabang = this.state.kodeCabang.map((item) => item.value);
    let transformFilterCDB = {};
    let trasformFilterH1 = {};
    let transformFilterH23 = {};

    const { filterCDB, filterH1, filterH23 } = this.state.filterData || {};

    if (filterCDB) {
      transformFilterCDB = {
        ...filterCDB,
        startDatePeriod: search ? filterCDB?.startDatePeriod : null,
        endDatePeriod: search ? filterCDB?.endDatePeriod : null,
        agama: getValueFromDDL(filterCDB, "agama"),
        jenisKelamin: getValueFromDDL(filterCDB, "jenisKelamin"),
        provinsi: getValueFromDDL(filterCDB, "province"),
        kabkot: getValueFromDDL(filterCDB, "kabkot"),
        kecamatan: getValueFromDDL(filterCDB, "kecamatan"),
        kelurahan: getValueFromDDL(filterCDB, "kelurahan"),
        kodePos: getValueFromDDL(filterCDB, "zipCode"),
        memberLevel: getValueFromDDL(filterCDB, "memberLevel"),
        loyaltyLevel: getValueFromDDL(filterCDB, "loyaltyLevel"),
        facebook: getValueFromDDL(filterCDB, "facebook"),
        instagram: getValueFromDDL(filterCDB, "instagram"),
        x: getValueFromDDL(filterCDB, "x"),
        linkedin: getValueFromDDL(filterCDB, "linkedin"),
        tiktok: getValueFromDDL(filterCDB, "tiktok"),
        hobby: filterCDB?.hobby
          ? filterCDB?.hobby.map((item) => item.value)
          : null,
        interest: filterCDB?.interest
          ? filterCDB?.interest.map((item) => item.value)
          : null,
        kategoriDisc: getValueFromDDL(filterCDB, "kategoriDisc"),
        kategoriKhusus: getValueFromDDL(filterCDB, "kategoriKhusus"),
      };
    }

    if (filterH1) {
      let { tanggalFJ, ...otherFilterH1 } = filterH1;
      trasformFilterH1 = {
        ...otherFilterH1,
        startDateFJ: tanggalFJ?.startDateFJ,
        endDateFJ: tanggalFJ?.endDateFJ,
        listSeries: filterH1?.listSeries
          ? filterH1?.listSeries.map((item) => item.value.toString())
          : null,
        listTipe: filterH1?.listTipe
          ? filterH1?.listTipe.map((item) => item.value.toString())
          : null,
        listVarian: filterH1?.listVarian
          ? filterH1?.listVarian.map((item) => item.value)
          : null,
        listWarna: filterH1?.listWarna
          ? filterH1?.listWarna.map((item) => item.value)
          : null,
        jenisPenjualan: getValueFromDDL(filterH1, "jenisPenjualan"),
        jenisKonsumen: getValueFromDDL(filterH1, "jenisKonsumen"),
        leasing: getValueFromDDL(filterH1, "leasing"),
        operatorTanggalBeliTerakhir: getValueFromDDL(
          filterH1,
          "operatorTanggalBeliTerakhir"
        ),
      };
    }

    if (filterH23) {
      transformFilterH23 = {
        ...filterH23,
        statusKPB1: getValueFromDDL(filterH23, "statusKPB1"),
        statusKPB2: getValueFromDDL(filterH23, "statusKPB2"),
        statusKPB3: getValueFromDDL(filterH23, "statusKPB3"),
        statusKPB4: getValueFromDDL(filterH23, "statusKPB4"),
        pembandingPengeluaran: getValueFromDDL(
          filterH23,
          "pembandingPengeluaran"
        ),
        pembandingServiceTerakhir: getValueFromDDL(
          filterH23,
          "pembandingServiceTerakhir"
        ),
        job: filterH23?.job ? filterH23?.job.map((item) => item.value) : null,
        part: filterH23?.part
          ? filterH23?.part.map((item) => item.value)
          : null,
      };
    }

    let { province, ...restCDB } = transformFilterCDB;

    const requestBody = {
      listKodeCabang,
      filterCDB: { ...removeNullFields(restCDB) },
      filterH1: { ...removeNullFields(trasformFilterH1) },
      filterH23: { ...removeNullFields(transformFilterH23) },
    };

    return removeNullFields(requestBody);
  };

  handleDisplayAll = async () => {
    this.handleTriggerLoading();
    this.handleRefreshPagination();
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getDataForCreateProspect,
      setError: this.props.setError,
      menuName: "CRM Management CDB",
      args: {
        listKodeCabang: this.state.kodeCabang.map((item) => item.value)
      },
    });

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prevValue) => ({
        ...prevValue,
        dataTable: res.data.data,
        pagination:{
          limit: 5,
          page: 1,
          totalData: res.data.totalData
        }
      }));
    }
    this.handleTriggerLoading();
  };

  handleSubmitSearch = async (search = false) => {
    this.handleTriggerLoading();
    await this.reFetchApi(search);
    this.handleTriggerLoading();
  };

  // handleRefreshPagination = () => {
  //   this.setState((prevState) => ({
  //     ...prevState,
  //     pagination: {
  //       totalData: 1,
  //       limit: 5,
  //       page: 1,
  //     },
  //   }));
  // };

  handleRefreshPagination = (resetPage = false) => {
    this.setState((prevState) => ({
      ...prevState,
      pagination: {
        ...prevState.pagination,
        page: resetPage ? 1 : prevState.pagination.page,
      },
    }));
  };

  render() {
    return (
      <>
        <Container>
          <SimpleDDL
            id="select_options_kode_cabang"
            box="multiselect"
            name="kodeCabang"
            containerclassname="width width-350px"
            placeholder="Nama Cabang"
            menuPosition="fixed"
            options={this.state.cabangOptions}
            value={this.state.kodeCabang}
            onChange={(value) => this.handleChangeKodeCabang(value)}
          />
          <Tabs
            selectedIndex={this.state.activeTabIndex}
            onSelect={this.handleTabSelect}
          >
            <TabList>
              <Tab>Create Prospek</Tab>
              <Tab>Permohonan Perubahan Data</Tab>
            </TabList>
            <TabPanel key={"create_prospek"}>
              <CrmCDBTab
                {...this.props}
                state={this.state}
                tab="create_prospek"
                onFilterVisibility={this.handleModalFilterVisibility}
                onResetFilter={this.handleResetFilter}
                onSubmitFilter={this.handleSubmitFilter}
                onDisplayAll={this.handleDisplayAll}
                onFetchData={this.fetchCreateProspek}
                onSetState={this.handleSetState}
                onSubmit={this.handleSaveCreateProspect}
              />
              <FlexView
                style={{
                  justifyContent: "right",
                  marginTop: "20px",
                  gap: "20px",
                }}
              >
                <SimpleButton text="CETAK" onClick={this.print} />
                {/* <SimpleButton
                  text="BUAT PROSPEK H23"
                  onClick={()=> this.checkEligibleNIKForProspect(true)}
                /> */}
                <SimpleButton
                  text="BUAT PROSPEK H1"
                  onClick={()=> this.checkEligibleNIKForProspect()}
                />
              </FlexView>
            </TabPanel>
            <TabPanel key={"change_data"}>
              <CrmCDBTab
                {...this.props}
                state={this.state}
                tab="change_data"
                onFilterVisibility={this.handleModalFilterVisibility}
                onResetFilter={this.handleResetFilter}
                onSubmitFilter={this.handleSubmitFilter}
                onSubmitSearch={this.handleSubmitSearch}
                onFetchData={this.fetchChangeData}
                onSetState={this.handleSetState}
                onCancel={this.handleCancelChangeRequest}
                onProcess={this.handleProcessChangeRequest}
                filterData={this.state.filterData}
                // firstLoad={this.state.firstLoad}
              />
            </TabPanel>
          </Tabs>
        </Container>

        {this.state.alertModalSaveVisible && (
          <SimpleAlert
            title={"Information"}
            content={"Data Berhasil Dibuat!"}
            visible={this.state.alertModalSaveVisible}
            onClickClose={this.handleAlertModalSaveVisibility}
            additionalButtons={
              <FlexView>
                <SimpleButton
                  type="button"
                  text="OK"
                  onClick={() => this.handleAlertModalSaveVisibility()}
                />
              </FlexView>
            }
          />
        )}

        {this.state.alertModalValidationVisible && (
          <SimpleAlert
            title={"Information"}
            content={
              "Belum ada data yang dipilih, Harap pilih data customer terlebih dahulu"
            }
            visible={this.state.alertModalValidationVisible}
            onClickClose={this.alertModalValidationVisible}
            additionalButtons={
              <FlexView>
                <SimpleButton
                  type="button"
                  text="OK"
                  onClick={() => this.handleAlertModalValidationVisibility()}
                />
              </FlexView>
            }
          />
        )}

        {this.state.confirmationVisible && (
          <SimpleAlert
            title={"Information"}
            content={
              <div>
                <p>Prospek {this.state.prospectCategory} dengan data:</p>
                {this.state.numberOfEligible > 0 && (
                  <p>
                    - Total {this.state.numberOfEligible} Data akan dibuat
                    Prospek.
                  </p>
                )}
                {this.state.numberOfNotEligible > 0 && (
                  <p>
                    - Total {this.state.numberOfNotEligible} Data sudah memiliki
                    Prospek sehingga TIDAK DIPROSES.
                  </p>
                )}
                <p>Apakah anda yakin?</p>
              </div>
            }
            visible={this.state.confirmationVisible}
            onClickClose={this.handleConfirmationVisibility}
            additionalButtons={
              <FlexView style={{ justifyContent: "right", gap: "20px" }}>
                <SimpleButton
                  type="button"
                  text="Batal"
                  secondary
                  onClick={this.handleConfirmationVisibility}
                />
                <SimpleButton
                  type="button"
                  text="OK"
                  onClick={this.createProspectH1}
                />
              </FlexView>
            }
          />
        )}

        {this.state.visibleConfirm && (
            <SimpleAlert
                visible={this.state.visibleConfirm}
                title={"Information"}
                onClickClose={this.handleVisibletConfirm}
                content={
                    <div>
                        <p dangerouslySetInnerHTML={{ __html: this.state.responseContent }} />
                        <FlexView hAlignContent="center">
                            <SimpleButton
                                className="margin-top-15px"
                                text="OK"
                                onClick={this.handleVisibletConfirm}
                            />
                        </FlexView>
                    </div>
                }
            />
        )}

        {this.state.loading && (
          <SimpleLoadingOverlay active={this.state.loading} />
        )}
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

export default connect(null, mapDispatchToProps)(CrmCDB);
